class VideoCaption {
	constructor(container) {
		this.timeout = null;
		this.container = container;
		this.video = container.querySelector('video');
		this.img = container.querySelector('img');
		this.playButton = container.querySelector('.play');

		this.playButton.addEventListener('click', () => this.onVideoPlay());
		this.video.addEventListener('ended', () => this.onVideoStop());
		this.video.addEventListener('pause', () => this.onVideoStop());
	}

	onVideoPlay(e) {
		// e.preventDefault();
		clearTimeout(this.timeout);
		this.container.classList.add('animate');
		this.video.play();

		this.timeout = setTimeout(() => {
			this.container.classList.add('playing');
		}, 500);
	}

	onVideoStop() {
		clearTimeout(this.timeout);
		this.container.classList.remove('animate', 'playing');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const videoContainers = document.querySelectorAll('.videocaption__content');
	videoContainers.forEach(container => new VideoCaption(container));
});